<!--列表：图左文右 图右文左-->
<template>
  <div class="v-list">
      <el-row :gutter="10">
          <el-col :xs="24" 
                  :sm="24"
                  :md="24"
                  :lg="24"
                  :xl="24"
                  :class="listClass+'A listOne imgOne '+cardStyle"
                  v-for="(item,index) in listVal.card.carditem" :key="index" @click.native="linkUrl(item.url)">
                  <el-row :class="item.url?'click':''" v-if="position=='left-right'">
                    <el-col :span="getGridOne(item.txt,item.img,duty,1)">
                      <img  :src="address+item.img" :onerror="item.img"/>
                    </el-col>
                    <el-col :span="getGridOne(item.txt,item.img,duty,0)">
                      <div class="content"  v-html="mark(item.txt)"></div>
                    </el-col>
                  </el-row>
                  <el-row :class="item.url?'click':''" v-else>
                    <el-col :span="getGridOne(item.txt,item.img,duty,0)">
                      <div class="content"  v-html="mark(item.txt)"></div>
                    </el-col>
                    <el-col :span="getGridOne(item.txt,item.img,duty,1)">
                      <img  :src="address+item.img" :onerror="item.img"/>
                    </el-col>
                  </el-row>
          </el-col>
      </el-row>
  </div>
</template>

<script>
import marked from 'marked'
export default {
  name: 'v-list',
  props: {
      listVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      // address:"http://10.16.54.158:9018",
      address:"",
      defaultOpen:"preview",
      position:"left",//left right 默认左右（非必填）
      blockSize:"x_small",//small middle large xlarge 默认small（非必填）
      blockImg:"square",//square rect 默认small（非必填）
      blockType:"deafult",//deafult card 默认deafult（非必填）
      blockRadius:"fillet",//'' fillet:50% 默认''（非必填）
      listClass:"listOneA",
      duty:"",//比例
      cardStyle:"",
    }
  },
  created(){
    var that = this;
    that.position = that.getAttr(that.listVal.card.attr,'position');
    // console.log("this.listVal.card.attr:::",this.listVal.card.attr);
    that.blockSize = that.getAttr(that.listVal.card.attr,"size")?that.getAttr(that.listVal.card.attr,"size"):"";
    that.listClass = that.getAttr(that.listVal.card.attr,"listClass")?that.getAttr(that.listVal.card.attr,"listClass"):"listOneA";
    that.cardStyle = that.getAttr(that.listVal.card.attr,"imgTextStyle")?that.getAttr(that.listVal.card.attr,"imgTextStyle"):"";
    that.duty = that.getAttr(that.listVal.card.attr,"duty")?that.getAttr(that.listVal.card.attr,"duty"):"";// that.listStyle = that.getAttr(that.listVal.card.attr,"imgStyle")?that.getAttr(that.listVal.card.attr,"imgStyle"):"";
    // console.log("that.getAttr(that.listVal.card.attr,'imgStyle'):",that.getAttr(that.listVal.card.attr,"imgStyle"));
  },
  methods:{
    linkUrl(_url){
      var that = this;
      if(_url!==""&&_url!==null){
        if(_url.indexOf("http")>=0||_url.indexOf("https")>=0){
          window.open(_url);
        }else{
          that.$router.push({'name':'build',query:{"id":_url}});
        }
      }
      return;
    },
    //转换md格式
    mark(_value){
      return marked(_value);
    },
    //转换样式
    getAttr(_attr,_type){
      var data={};
      if(_attr!==''){
        data=JSON.parse(_attr);
        return data.[_type];
      }
    },
    //获取列表栅格
    // getSpan(_txt,_img,_size,_type){
    //   //_type 0内容1图片
    //   if(_size=="x_middle"){
    //       return  _type==0&&_txt&&_img?18
    //             : _type==1&&_txt&&_img?6
    //             :24;
    //   }else if(_size=="x_large"){
    //       return  _type==0&&_txt&&_img?14
    //             : _type==1&&_txt&&_img?10
    //             :24;
    //   }else if(_size=="x_largel"){
    //       return  _type==0&&_txt&&_img?12 
    //             : _type==1&&_txt&&_img?12
    //             :24;
    //   }else{
    //     return  _type==0&&_txt&&_img?20 
    //           : _type==1&&_txt&&_img?4
    //           :24;
    //   }
    // },
    //左右栅格比例
    getGridOne(_txt,_img,_duty,_type){
      //_txt  文字内容
      //_img  图片url
      //_duty 栅格比列
      //_type 0图片 1文字
      var grid = 0;
      if(_txt!==''&&_img!==''){
        switch (_duty=='dutyOne'?0:_duty=='dutyThree'?1:2) {
          case 0:
            grid =  _type==0?16:8;
            break;
          case 1:
            grid =  _type==1?16:8;
            break;
          default:
            grid = 12;
        }
        //  grid = 24;
      }else if((_txt==''&&_img!==''&&_type==1)||(_txt!==''&&_img==''&&_type==0)){
        grid = 24;
      }else{
        grid = 0;
      }
      return grid;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
